import toastr from 'toastr'
import layout from 'layouts/default'
import generalTab from './generalTab'
import commissions from './commissions'
import coupons from './coupons'
import fees from './fees'
import parkingTypesCarStructure from './parkingTypesCarStructure'
import cancellationPolicy from './cancellationPolicy'
import extraFields from './extraFields'
import { hasPermits } from 'directives'
// import './details.scss'
import { helper} from 'services'

const directives = {
  hasPermits
}

const components = {
  layout,
  generalTab,
  commissions,
  coupons,
  fees,
  parkingTypesCarStructure,
  cancellationPolicy,
  extraFields
}

const computed = {
  location () {
    return _.cloneDeep(this.$store.state.locations.active);
  },
  // channels() {
  //   return _.cloneDeep(this.$store.state.locations.active.channels);
  // },
  currencies () {
    return [].concat(this.$store.state.currencies.all);
  },
}

const watch = {
  location () {
    this.form = _.assign(this.form, _.cloneDeep(this.location));
    try {
      this.form.channels = this.location.channels.map((item) => ({
        id: item.channel.id,
        name: item.channel.name,
        domain: item.channel.domain,
        bundle_commission: item.bundle_commission,
        parking_commission_type: item.parking_commission_type,
        parking_commission: item.parking_commission,
        room_commission: item.room_commission,
        accept_coupon: item.accept_coupon,
        coupon_limit: item.coupon_limit,
        coupon_limit_type: item.coupon_limit_type
      }))
    } catch (e) {}
  },

  ['form.credit_card_required'] (n, o) {
    this.checkDisabled(n, o);
  },

  ['form.room_due_at_location'] (n, o) {
    this.checkDisabled(n, o);
  }
}

const methods = {
  async submitEditLocation () {
    this.errors = {}
    this.submit_loading = true;

    await this.$store.dispatch('locations.get', {id : this.$route.params.id, save_active: false}).then((response) => {
      this.db_location_data = response.data;
    });

    if (!helper.validateChanges(this.keys, this.form, this.initiate_location_data, this.db_location_data)) {
      toastr.error("someone else is making changes to this page, please copy your changes, refresh and do it again.");
      this.submit_loading = false;
      return;
    }

    this.form.parking_due_at_location = this.form.parking_due_at_location ? 1 : 0;
    this.form.room_due_at_location = this.form.room_due_at_location ? 1 : 0;
    this.form.printed_receipt = this.form.printed_receipt ? 1 : 0;
    this.$store.dispatch('locations.edit', {id: this.$route.params.id, data: this.form}).then(() => {

      if (this.$store.state.locations.errors) {
        this.errors = _.cloneDeep(this.$store.state.locations.errors.errors);
        toastr.error(this.$store.state.locations.errors.message);
        this.submit_loading = false;
      } else {
        this.$store.dispatch('locations.getChannels', this.$route.params.id)
        .then(() => {
          toastr.success('Data has been saved');
          this.initiate_location_data = _.cloneDeep(this.location);
          this.submit_loading = false;
        })
      }
    })
  },
  displayErrors (errors) {
    this.errors = _.cloneDeep(errors);
  },
  checkDisabled (n, o) {
    if (n == o) return  this.disabled = false;
    if (this.form.credit_card_required && !this.form.room_due_at_location) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  },
}

export default {
  name: "booking-conditions",
  components,
  computed,
  watch,
  methods,
  directives,
  data () {
    return {
      locId: this.$route.params.id,
      loading: false,
      submit_loading: false,
      disabled: false,
      errors: {},
      form: {
        tax_type: "gross",
        parking_due_at_location: false,
        room_due_at_location: false,
        credit_card_required: false,
        printed_receipt: false,
        daily_or_hourly: 'hourly',
        hours_before_reservation:0,
        hours_before_room_reservation: 0,
        block_extending_reservations: false,
        block_production_bookings: false,
        extend_reservation_when_check_out: false,
        channels: []
      },
      keys: [
        'hourly_checkin_limit', 'minimum_booking_days', 'hours_before_reservation', 'hours_before_room_reservation',
        'daily_or_hourly', 'currency_id', 'tax_type', 'tax_value', 'booking_days_limit', 'parking_due_at_location',
        'room_due_at_location', 'printed_receipt', 'credit_card_required', 'allow_refund_request', 'first_day_rate',
        'validate_phone_number', 'block_extensions_beyond_limit', 'one_car_per_booking', 'block_production_bookings',
        'block_extending_reservations', 'block_min_booking_days' 
      ],
      initiate_location_data: {},
      db_location_data: {},
    }
  }, created () {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('locations.get', {id: this.$route.params.id}),
      this.$store.dispatch('locations.getChannels', this.$route.params.id),
      this.$store.dispatch('locations.getFees', this.$route.params.id),
      this.$store.dispatch('locations.cancellationPolicies', this.$route.params.id),
      this.$store.dispatch('locations.extraFields', this.$route.params.id),
      this.$store.dispatch('currencies.getAll'),
      this.$store.dispatch('carTypes.getAllCarBodyTypes'),
      this.$store.dispatch('locations.parkingTypes', {id: this.$route.params.id,linked_location: false, with_car_types: true}),
    ]).then(() => {
      this.loading = false;
      this.initiate_location_data = _.cloneDeep(this.$store.state.locations.active);      
      try {
        this.form.channels = this.location.channels.map((item) => ({
          id: item.channel.id,
          name: item.channel.name,
          domain: item.channel.domain,
          parking_commission_type: item.parking_commission_type,
          parking_commission: item.parking_commission,
          room_commission: item.room_commission,
          bundle_commission: item.bundle_commission,
          accept_coupon: item.accept_coupon,
          coupon_limit: item.coupon_limit,
          coupon_limit_type: item.coupon_limit_type
        }))
      } catch (e) {}
    });
  }
}
